<template>
  <page>
    
    
    <head-nav :title="groupName">
      <icon-button-hamburger slot="left"></icon-button-hamburger>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>


    <scroll-menu>
      <scroll-button color="#666666" font-size="1.1em" icon="bullhorn" :to="'/group/'+id+'/news/'" title="language.group_news_button"></scroll-button>
      <scroll-button v-if="appSettings.modules.calendar=='1'" color="#666666" font-size="1.1em" icon="calendar" :to="'/group/'+id+'/calendar/'" title="language.group_calendar_button"></scroll-button>
      <scroll-button v-if="appSettings.modules.pictures=='1'" color="#666666" font-size="1.1em" icon="camera" :to="'/group/'+id+'/photoalbum/'" title="language.group_album_button"></scroll-button>
      <scroll-button v-if="appSettings.modules.emails=='1'" color="#666666" font-size="1.1em" icon="at" :to="'/group/'+id+'/emails/'" title="language.group_email_button"></scroll-button>
      <scroll-button v-if="appSettings.modules.documents=='1'" color="#666666" font-size="1.1em" icon="file" :to="'/group/'+id+'/documents/'" title="language.group_documents_button"></scroll-button>
      <scroll-button v-if="appSettings.modules.absences=='1' && computeUserAccess" color="#666666" font-size="1.1em" icon="thermometer" :to="'/group/'+id+'/absence/'" title="language.call_sick"></scroll-button>
      <scroll-button v-if="appSettings.modules.teacher_talks=='1' && computeUserAccess" color="#666666" font-size="1.1em" icon="comment" :to="'/group/'+id+'/talks/'" title="language.teacher_talks"></scroll-button>
    </scroll-menu>
   

    <router-view/>

   
  </page>
</template>

<script>

import Page from './Page.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
import ScrollMenu from '../components/scrollMenu/ScrollMenu.vue';
import ScrollButton from '../components/scrollMenu/ScrollButton.vue';
import { mapState } from 'vuex';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';

export default {
  name: 'group-page',
  data:function(){
    return{
      id:undefined,
      
    }
  },
  computed:{
     ...mapState([
       'groups','loaded','group','appSettings'
       ]),
       groupName:function(){
         return this.group ? this.group.name: "untitled";
       },
       computeUserAccess(){
        
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  components: {
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
    Page,
    ScrollMenu,
    ScrollButton,
 
  },
  methods:{
    findActiveGroup(){
      this.id=this.$route.params.id;
     // get group to display name in page
     var group = this.groups.find(group => group.id === this.id);
     this.$store.dispatch('set_group',{group:group});
    }
  },// methods{}
  mounted(){
     
  },
  created(){
    
    this.findActiveGroup();
  },
  watch: {
    "$route.params.id"() {
     //updating group
      this.findActiveGroup();
    },
},
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>